// extracted by mini-css-extract-plugin
export var container = "styles-module__container___bHF84";
export var doneButton = "styles-module__doneButton___P1D93";
export var menuContainer = "styles-module__menuContainer___M3cKt";
export var title = "styles-module__title___yxxAA";
export var titleAndMenu = "styles-module__titleAndMenu___dngAv";
export var toggleAndTitle = "styles-module__toggleAndTitle___czTE4";